import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const LoginForm = ({ onSubmit, loading, error }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSubmit(email, password);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-5">
      {/* Error message */}
      {error && (
        <div
          className="flex items-start gap-3 px-4 py-3 rounded-lg"
          style={{
            backgroundColor: 'rgba(220, 38, 38, 0.08)',
            border: '1px solid rgba(220, 38, 38, 0.25)',
          }}
        >
          <Icon name="AlertCircle" size={16} color="var(--color-error)" strokeWidth={2} className="mt-0.5 flex-shrink-0" />
          <span className="text-sm" style={{ color: 'var(--color-error)' }}>
            {error}
          </span>
        </div>
      )}
      {/* Email */}
      <div className="flex flex-col gap-1.5">
        <label
          htmlFor="email"
          className="text-sm font-medium"
          style={{ color: 'var(--color-foreground)' }}
        >
          Email
        </label>
        <div className="relative">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <Icon name="Mail" size={16} color="var(--color-muted-foreground)" strokeWidth={2} />
          </div>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e?.target?.value)}
            required
            autoComplete="email"
            disabled={loading}
            className="w-full h-11 pl-10 pr-4 rounded-lg text-sm transition-all duration-200"
            style={{
              backgroundColor: 'var(--color-input)',
              border: '1px solid var(--color-border)',
              color: 'var(--color-foreground)',
              outline: 'none',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = 'var(--color-accent)';
              e.target.style.boxShadow = '0 0 0 3px rgba(6, 214, 245, 0.12)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = 'var(--color-border)';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
      </div>
      {/* Password */}
      <div className="flex flex-col gap-1.5">
        <label
          htmlFor="password"
          className="text-sm font-medium"
          style={{ color: 'var(--color-foreground)' }}
        >
          Password
        </label>
        <div className="relative">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <Icon name="Lock" size={16} color="var(--color-muted-foreground)" strokeWidth={2} />
          </div>
          <input
            id="password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e?.target?.value)}
            required
            autoComplete="current-password"
            disabled={loading}
            className="w-full h-11 pl-10 pr-11 rounded-lg text-sm transition-all duration-200"
            style={{
              backgroundColor: 'var(--color-input)',
              border: '1px solid var(--color-border)',
              color: 'var(--color-foreground)',
              outline: 'none',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = 'var(--color-accent)';
              e.target.style.boxShadow = '0 0 0 3px rgba(6, 214, 245, 0.12)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = 'var(--color-border)';
              e.target.style.boxShadow = 'none';
            }}
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            className="absolute right-3 top-1/2 -translate-y-1/2 p-0.5 rounded transition-colors"
            style={{ color: 'var(--color-muted-foreground)' }}
            tabIndex={-1}
          >
            <Icon name={showPassword ? 'EyeOff' : 'Eye'} size={16} strokeWidth={2} />
          </button>
        </div>
      </div>
      {/* Submit */}
      <button
        type="submit"
        disabled={loading || !email || !password}
        className="w-full h-11 rounded-lg font-medium text-sm flex items-center justify-center gap-2 transition-all duration-200"
        style={{
          backgroundColor: loading || !email || !password ? 'var(--color-muted)' : 'var(--color-primary)',
          color: loading || !email || !password ? 'var(--color-muted-foreground)' : '#FFFFFF',
          cursor: loading || !email || !password ? 'not-allowed' : 'pointer',
          boxShadow: loading || !email || !password ? 'none' : 'var(--shadow-md)',
        }}
      >
        {loading ? (
          <>
            <div
              className="w-4 h-4 rounded-full border-2 border-t-transparent animate-spin"
              style={{ borderColor: 'currentColor', borderTopColor: 'transparent' }}
            />
            Signing in…
          </>
        ) : (
          <>
            <Icon name="LogIn" size={16} strokeWidth={2} />
            Sign In
          </>
        )}
      </button>
    </form>
  );
};

export default LoginForm;
